import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = ({ children}) => {
    const settings = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      };
    const containerRef = useRef(null);
    const [sliderCount, setSliderCount] = useState(0);
    useEffect(() => {
        const countSliders = () => {
          let count = 0;
          const container = containerRef.current;
    
          if (container) {
            const sliders = container.querySelectorAll('.slider');
            count = sliders.length;
          }
          setSliderCount(count);
        };
    
        countSliders();
      }, []);

    return (
        <div  ref={containerRef} className="max-w-[510px] relative mx-auto [&_.slick-dots]:bottom-[50px] [&_.slick-dots>li]:m-0 [&_.slick-dots>li>button:before]:hidden [&_.slick-dots>li>button]:w-[8px] [&_.slick-dots>li>button]:h-[6px] [&_.slick-dots>li>button]:bg-[#000] [&_.slick-dots>li>button]:rounded-full [&_.slick-dots>li>button]:p-0 [&_.slick-dots>li>button]:mx-auto [&_.slick-dots>li>button]:opacity-30 [&_.slick-dots>.slick-active>button]:w-[12px] [&_.slick-dots>.slick-active>button]:opacity-100">
        <Slider  {...settings}>
       {children}
      </Slider>
      <div className="bg-[#fff] text-black rounded-full py-1 text-[14px] w-fit absolute bottom-[20px] left-0 right-0 px-2 mx-auto shadow-md inline-flex"> 
      {sliderCount} Views
      </div>
      </div>
    );
};

export default ImageSlider;